// jQuery
// ------------------------------------------------------------------
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

// Global Variables
// ------------------------------------------------------------------
global.body = document.querySelector('body')
global.header = document.querySelector('header')
global.body = $('body')
global.header = $('header')
global.footer = $('footer')
global.main = $('main')
global.bgOverlay = $('.bg-overlay')
global.windowWidth = window.innerWidth;
global.windowHeight = window.innerHeight;
global.logoOrigin = '../assets/image/brand/logo.png'
global.logoWhite = '../assets/image/brand/logo-white.png'

// ScrollReveal
// ------------------------------------------------------------------
import ScrollReveal from 'scrollreveal';
window.ScrollReveal = ScrollReveal;